import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Link,
  Button,
  Grid,
  TextField,
  InputAdornment,
  List,
  ListItemText,
  ListItem,
  Pagination,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { useNavigate, useParams } from "react-router-dom";
import TotalUserTable from "../AssignTask/TotalUserTable";
import ScheduledAssign from "../AssignTask/ScheduledAssign";
import AssignTotalUserTable from "./AssignTotalUserTable";
import { getToken } from "../../utils/utils";
import { getalltaskbyid } from "./api";
//import ScheduledAssign from "./ScheduledAssign";


interface TaskData {
  task_name: string;
  credit_points: string;
  durations: string;
}
export default function ActiveAssignTask() {
  const navigate = useNavigate();
  const [gettaskdata, setgettaskdata] = useState<TaskData | null>(null);
  const token = getToken();
  const { maintaskid } = useParams();
  function setSearchTerm(value: string): void {
    throw new Error("Function not implemented.");
  }
  const [cortView, setCortView] = useState();

  useEffect(() => {
    const fetchAllTaskIds = async () => {
      try {
        const reqBody = { task_id: String(maintaskid) };
        const response = await getalltaskbyid(reqBody, token);
        const brandDetailsData = response?.data?.data || [];

        console.log(brandDetailsData, "Fetched task data");
        setgettaskdata(brandDetailsData);
      } catch (error) {
        console.error("Error fetching task name:", error);
      }
    };

    if (maintaskid && token) {
      fetchAllTaskIds(); // Call the function when dependencies are present
    }
  }, [maintaskid, token]);
  console.log(gettaskdata, "gettaskdatagettaskdata")
  return (
    <div>
      <Box sx={{ padding: "24px 32px 35px", background: "#fff " }}>
        <Link
          href="/manage-task"
          sx={{
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: "500",
            color: "rgba(105, 106, 107, 1)",
          }}
        >
          Tasks /
        </Link>
        <Link
          sx={{
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: "600",
            color: "rgba(142, 2, 15, 1)",
          }}
        >
          Assign Task
        </Link>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Typography
              variant="h3"
              sx={{
                fontSize: "24px",
                fontWeight: "600",
                color: "#000",
                marginTop: "16px",
              }}
            >
              {gettaskdata?.task_name}
            </Typography>
            <Box sx={{ width: "100%", background: "#F9FBFC", padding: "0 20px", marginTop: "20px", borderRadius: "10px" }}>
              <List sx={{ display: "flex", width: "300px" }}>
                <ListItem sx={{ paddingLeft: "0" }}>
                  <label style={{ color: "#494A4B" }} htmlFor="name">
                    Points:
                  </label>
                  <strong id="name">  {gettaskdata?.credit_points} Pts</strong>
                </ListItem>
                {/* <ListItem sx={{ paddingLeft: "0" }}>
                  <label htmlFor="name">Duration:</label>
                  <strong id="name">{gettaskdata?.durations}</strong>
                </ListItem> */}
              </List>
            </Box>
          </Box>

        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "30px;",

          }}
        >
          <TextField
            required
            placeholder="Search by Task, PMI Entity Code, Outlet Name, size & Location"
            sx={{
              ".MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: "48px",
                width: "521px",

              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            value={setSearchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Box>
      </Box>
      <Box
        sx={{
          background: "#F9FBFC",
          borderTop: "1px solid rgba(0, 0, 0, 0.12)",
          padding: "20px 32px 20px",
        }}
      >
        <AssignTotalUserTable taskId={""} token={""} />
      </Box>
      <Box sx={{ position: "relative", width: "100%", marginTop: "50px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#fff",
            padding: "20px 32px",
            borderTop: "1px solid #d8d8d8",
            marginTop: "0px",
            position: "fixed",
            bottom: "0",
            width: "82%",
          }}
        >
          <Box>
            <Link href="/manage-task" style={{ textDecoration: "none" }}>
              <Typography sx={{ color: "#C8172F", fontSize: "14px", cursor: "pointer" }}>
                ← Back
              </Typography>
            </Link>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
